import { createSelector } from "@reduxjs/toolkit";
import { Columns } from "../../types/state";
import { RootState } from "src/store/rootReducer";
import { NameSpace } from "../../const";

export const getColumns = createSelector(
  (state: RootState) => state.vpoStrapi[NameSpace.Columns],
  (state: Columns) => state.data
);

export const getFetchingStatusColumns = createSelector(
  (state: RootState) => state.vpoStrapi[NameSpace.Columns],
  (state: Columns) => state.fetchingStatusColumns
);
